import type { EmbedProvider } from '../Provider.types';
import { SpotifyResourceCard } from './SpotifyResourceCard';
import { parseSpotifyUrl } from './spotifyUrl';

export const Spotify: EmbedProvider = {
  domains: ['open.spotify.com'],
  parseEmbed: (url) => {
    const resource = parseSpotifyUrl(url);
    return resource ? { type: 'url', value: resource.href } : null;
  },
  renderEmbed: (data) => {
    if (data.type !== 'url') return null;
    const resource = parseSpotifyUrl(data.value);
    return resource ? <SpotifyResourceCard key={resource.href} url={resource.href} /> : null;
  },
};
